export {
  BirthdateField,
  type BirthdateFieldProps,
} from '../../compositions/shared/BirthdateField';
